// extracted by mini-css-extract-plugin
module.exports = {"easterEgg":"EasterEgg_easterEgg__KqlPW"};